var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8152_13699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.75 7L14 3.25L4 13.25V17H7.75L17.75 7ZM20.71 4.04C20.8027 3.94749 20.8762 3.8376 20.9264 3.71663C20.9766 3.59565 21.0024 3.46597 21.0024 3.335C21.0024 3.20403 20.9766 3.07435 20.9264 2.95338C20.8762 2.8324 20.8027 2.72252 20.71 2.63L18.37 0.290003C18.2775 0.197299 18.1676 0.123752 18.0466 0.0735701C17.9257 0.0233886 17.796 -0.00244141 17.665 -0.00244141C17.534 -0.00244141 17.4043 0.0233886 17.2834 0.0735701C17.1624 0.123752 17.0525 0.197299 16.96 0.290003L15 2.25L18.75 6L20.71 4.04Z",
    fill: "#0076FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20H24V24H0V20Z",
    fill: "#A4C4E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8152_13699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRename);
export default __webpack_public_path__ + "static/media/rename.be89a52df32b0900ebff20f91fbbffce.svg";
export { ForwardRef as ReactComponent };